import React, { useState } from "react";
import {
  Box,
  Switch,
  Typography,
  Button,
  Link,
  Divider,
  useTheme,
  Grid,
  useMediaQuery,
} from "@mui/material";
import {
  blackShade19,
  blackShade21,
  blueColor04,
  greyColor40,
  logoImgborder1,
  whiteColor,
  yellowShade03,
} from "../../configs/styles/muiThemes";
import StyledSwitch from "../../components/Switch/StyledSwitch";

const AffiliateMarketingSummary = ({businessAffiliateInfo}) => {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const [enabled, setEnabled] = useState(true);
  const theme = useTheme();

  const handleToggleChange = () => {
    setEnabled(!enabled);
  };

  return (
    <Box sx={styles.infoBox}>
      <Grid container alignItems="center" spacing={{xs:1.5, md:3}}>
        <Grid item xs={12} md={6.45}>
          <Box>
            <Box
              sx={{ flex: 1, display: "flex", alignItems: "center", gap: 0.5 }}
            >
              <Typography
                fontSize={13}
                fontWeight={400}
                color={greyColor40}
                lineHeight="15px"
              >
                Affiliate Marketing enabled
              </Typography>

              <Box mt={-0.5}>
                <StyledSwitch
                  label="Yes"
                  isChecked={true}
                  onChange={() => {}}
                  gap={0.3}
                  labelFontSize={matches ? 14 : 12.5}
                  labelFontWeight={600}
                />
              </Box>
            </Box>

            <Typography
              sx={{
                fontSize: 12,
                fontWeight: 500,
                color: blackShade21,
                mt: -0.6,
              }}
            >
              For disabling Affiliate Marketing or to update commissions, contact{" "}
              <Typography
                component="span"
                fontSize={12}
                fontWeight={500}
                color={blueColor04}
                // sx={{ textDecoration: "underline" }}
              >
                support@costbo.com
              </Typography>
            </Typography>
          </Box>
        </Grid>

        {matches && (
          <Grid item xs={0.2} md={0.2}>
            <Divider
              orientation="vertical"
              flexItem
              sx={{ height: "30px", mt: 1 }}
            />
          </Grid>
        )}

        <Grid item xs={12} md={5.2}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 3,
              mt: { xs: "0px", md: "5px" },
              ml: { xs: "0px", md: "15px" },
            }}
          >
            <Box>
              <Typography fontSize={12} fontWeight={600} color={blackShade19}>
                Commission ={" "} 
                <Typography
                  component="span"
                  fontSize={13}
                  sx={{ color: yellowShade03, fontWeight: 600 }}
                >
                  {businessAffiliateInfo?.affiliatePercentage || '-'}%
                </Typography>
              </Typography>
            </Box>

            <Box>
              <Typography fontSize={12} fontWeight={600} color={blackShade19}>
                Customer Discount ={" "}
                <Typography
                  component="span"
                  fontSize={13}
                  sx={{ color: yellowShade03, fontWeight: 600 }}
                >
                  {businessAffiliateInfo?.consumerPercentage || '-'}%
                </Typography>
              </Typography>
            </Box>

<Box />
            {/* <Button
              variant="outlined"
              sx={{
                fontSize: {xs:11, md:12},
                fontWeight: 600,
                border: `1px solid ${yellowShade03}`,
                p: {xs:'2px 16px', md:"4px 16px"},
                color: yellowShade03,
                bgcolor: whiteColor,
                "&:hover": {
                  border: `1px solid ${yellowShade03}`,
                  color: whiteColor,
                  bgcolor: yellowShade03,
                },
              }}
            >
              CHANGE
            </Button> */}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AffiliateMarketingSummary;

const styles = {
  infoBox: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: whiteColor,
    baxShadow: "0 3px 4px rgb(229 233 240 / 22%)",
    padding: "8px 15px 15px 15px",
    border: logoImgborder1,
    borderRadius: "10px",
    marginTop: { xs: "10px", md: "15px" },
    overflow: "hidden",
  },
};
